export default "__VITE_ASSET__hvd6praT__"